const BROWSERSLIST = {
  CHROME: '64', // Required for ResizeObserver
  SAFARI: '13.1', // Required for ResizeObserver
  FIREFOX: '70',
  IOS: '13.4',
};

export default BROWSERSLIST;
